import { render, staticRenderFns } from "./file3.vue?vue&type=template&id=b33862cc&scoped=true"
import script from "./file3.vue?vue&type=script&lang=js"
export * from "./file3.vue?vue&type=script&lang=js"
import style0 from "./file3.vue?vue&type=style&index=0&id=b33862cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33862cc",
  null
  
)

export default component.exports